import React, { useEffect, useRef } from "react";
import styles from "./WishlistWidgetWrapper.module.css";
import { useFlightWishlistAdaptor } from "./useFlightWishlistAdaptor.js";
import useClientMetrics from "../../../hooks/useClientMetrics.js";
const RENDER_TIMEOUT_MS = 5000;
const WishlistWidgetWrapper = ({ flight }) => {
    const { flightPriceDetails, flightSegmentDetails, ...searchDetails } = useFlightWishlistAdaptor(flight);
    const { trackClientMetric } = useClientMetrics();
    const divRef = useRef(null);
    const hasTrackedRef = useRef(false);
    useEffect(() => {
        const timeoutId = setTimeout(() => {
            if (hasTrackedRef.current || !divRef.current)
                return;
            if (divRef.current.children.length > 0) {
                trackClientMetric("js_wishlist_widget_render_success");
            }
            else {
                trackClientMetric("js_wishlist_widget_render_failed");
            }
            hasTrackedRef.current = true;
        }, RENDER_TIMEOUT_MS);
        return () => clearTimeout(timeoutId);
    }, [trackClientMetric]);
    if (!flight || !flightSegmentDetails || !flightPriceDetails) {
        return null;
    }
    const { token, offerKeyToHighlight } = flight;
    const flightProps = {
        token,
        flightKey: offerKeyToHighlight,
        flightSearchDetails: searchDetails,
        flightSegmentDetails,
        ...flightPriceDetails
    };
    return React.createElement("div", { ref: divRef, className: styles.wishlistWidget, "data-wishlist-flight": JSON.stringify(flightProps) });
};
export default WishlistWidgetWrapper;
